import { BattleState, Monster, TurnCommands, TurnResult } from '../types';
import { processTurn } from '../battle/turnProcessor';

/**
 * Lv6 達人 AI のゲーム木探索用ターン進行シミュレーター
 *
 * 既存の `processTurn()` を randomFn 注入で AI 用に再利用するラッパー。
 * 探索時に乱数依存があると α-β 剪定の決定性が崩れるため、
 * 探索ノードでは決定論的に動かす必要がある。
 *
 * PR2 初版では「常に必中（randomFn = () => 1.0）」で実装する。
 * 回避がほぼ起きないため、回避が頻繁に発生するマッチアップ（高速モンスター対）
 * では精度が落ちる。Lv5 への勝率が 60% 未達なら期待値補正版に進化させる。
 */

const NEVER_EVADE: () => number = () => 1.0;

/**
 * 1ターン分（1st + 2nd + ダメージ + ターン終了処理）を決定論的に進める
 *
 * - 回避は起きない前提（randomFn = () => 1.0）
 * - 入力 state はミューテートしない
 *
 * @returns 進行後の新しい BattleState と、発生した TurnResult
 */
export function simulateTurnDeterministic(
  state: BattleState,
  monster1: Monster,
  monster2: Monster,
  p1Commands: TurnCommands,
  p2Commands: TurnCommands,
): { newState: BattleState; turnResult: TurnResult } {
  return processTurn(state, monster1, monster2, p1Commands, p2Commands, NEVER_EVADE);
}
